module.exports = {
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/react-intro-more-on-jsx.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/react-intro-more-on-jsx.json
// module chunks = 9763580899027520000